/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DailyPayment
 */
export interface DailyPayment {
    /**
     * 
     * @type {number}
     * @memberof DailyPayment
     */
    aggregatePayment: number;
    /**
     * 
     * @type {string}
     * @memberof DailyPayment
     */
    date: string;
}

/**
 * Check if a given object implements the DailyPayment interface.
 */
export function instanceOfDailyPayment(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "aggregatePayment" in value;
    isInstance = isInstance && "date" in value;

    return isInstance;
}

export function DailyPaymentFromJSON(json: any): DailyPayment {
    return DailyPaymentFromJSONTyped(json, false);
}

export function DailyPaymentFromJSONTyped(json: any, ignoreDiscriminator: boolean): DailyPayment {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'aggregatePayment': json['aggregate_payment'],
        'date': json['date'],
    };
}

export function DailyPaymentToJSON(value?: DailyPayment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'aggregate_payment': value.aggregatePayment,
        'date': value.date,
    };
}

